import { useState } from "react";
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper";
import FilterTabsCommon from "../../../../components/common/FilterTabsCommon/FilterTabsCommon";
import GrayDivider from "../../../../components/common/AdminCommonComponents/GrayDivider/GrayDivider";
import StoreThemes from "./StoreThemes/StoreThemes";
import CustomPages from "./CustomPages/CustomPages";

const StoreSetting = () => {

  const tabs = [
    { id: 'storeThemes', label: 'Store Themes' },
    { id: 'customPages', label: 'Custom Pages' },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].id)

  const renderTab = {
    storeThemes: <StoreThemes />,
    customPages: <CustomPages />,
  }

  return (
    <LightGrayBgWrapper>
      <div className="fs-4 fw-semibold">Store Setting</div>
      <FilterTabsCommon activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
      <GrayDivider />

      {renderTab[activeTab] || null}
    </LightGrayBgWrapper>
  );
};

export default StoreSetting;